module.exports = __webpack_public_path__ + "static/media/ke.e586b36d.webp";